<a [href]="telHref" data-testid="support-contact-number">{{ phone }}</a>
